module.exports = __webpack_public_path__ + "img/ltkhome-3x.ceb37b3.jpg";